export const environment = {
  authorization: {
    issuer: 'https://sso.myshareview.com',
    clientId: 'shareview-config',
    scope: 'openid profile offline_access roles shareview',
  },
  apiBaseUrl: 'https://api.myshareview.com',
  appId: 4,
  environment: 'prod',
  applicationInsights: {
    instrumentationKey: '623ddb04-2277-4788-a099-01986f261d4c',
  },
};
